import { render, staticRenderFns } from "./funIntro.vue?vue&type=template&id=378dd9ca&scoped=true&"
import script from "./funIntro.vue?vue&type=script&lang=js&"
export * from "./funIntro.vue?vue&type=script&lang=js&"
import style0 from "./funIntro.vue?vue&type=style&index=0&id=378dd9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378dd9ca",
  null
  
)

export default component.exports